'use client';

import { CatRadioField } from '@blocks-react/components/RadioField';
import { CatFieldset } from '@blocks-react/components/Fieldset';
import { useRadioController } from '../../../../hooks/form-controllers';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { getDefaultValue } from '../../utils';
import { OrderType, StoreLocation } from '../../types';
import styles from '../../AssociatedDealer.module.scss';
import { BlocksRadioChangeEvent } from '@blocks-web-components/events';

interface Props {
  name: string;
  selectedStoreLocation: StoreLocation;
  stock: OrderType;
  standard: OrderType;
  label: string;
  onChange?: (e: BlocksRadioChangeEvent) => void;
}

export const AssociatedDealerOrderType = ({
  name,
  selectedStoreLocation,
  stock,
  standard,
  label,
  onChange
}: Props) => {
  const defaultValue = getDefaultValue([stock, standard]);
  const { setValue, resetField, control } = useFormContext();
  const { getRadioField, radioFieldset } = useRadioController(
    {
      control,
      name
    },
    onChange
  );

  useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue.value);
    } else {
      resetField(name);
    }

    return () => {
      resetField(name);
    };
  }, [selectedStoreLocation]);

  return (
    <CatFieldset required={true} {...radioFieldset}>
      <div className="cat-u-theme-typography-label">
        {label}
        <span className={styles['required-field']}>{' (required)'}</span>
      </div>
      <CatRadioField {...getRadioField('order-type-stock', stock.value)}>
        {stock.label}
      </CatRadioField>
      <CatRadioField {...getRadioField('order-type-standard', standard.value)}>
        {standard.label}
      </CatRadioField>
    </CatFieldset>
  );
};
